import type { Client_WorkingAreas } from '../getClientWorkingAreas';
import hasSelfIntersection from '../hasSelfIntersection';

/**
 * Returns true when any working area polygon has edges that cross each other.
 */
const hasSelfIntersectingWorkingAreas = (
  workingAreas: Client_WorkingAreas,
): boolean => workingAreas.some(area => hasSelfIntersection(area.feature));

export default hasSelfIntersectingWorkingAreas;
